import merge from 'lodash/merge';
import FHIRObjectBase from './FHIRObjectBase';
import CodeableConcept from './types/CodeableConcept';
import Quantity from './types/Quantity';

export default class CarePlanTarget extends FHIRObjectBase {
    static __className = 'CarePlanTarget';

    // Flat slice keys match the FCE migration for CarePlan-measurementTarget.
    // Diverges from GoalTarget's DetailX wrapper because Aidbox's FCE flattening
    // exposes the polymorphic detail[x] as flat sibling keys for custom extensions.
    __objectStructure = {
        measure: CodeableConcept,
        detailQuantity: Quantity,
        detailString: String,
    };

    constructor(constructJson, className = 'CarePlanTarget') {
        // Tolerate the codebase's nested polymorphic shape (`detail: { Quantity }`
        // / `detail: { string }`) on input — buildTargets and any caller using
        // DetailX-style input still flow through unchanged.
        const normalized = CarePlanTarget.normalize(constructJson);
        super(normalized, className);
        this.createAndPopulateStructure(this.__objectStructure, normalized, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    static normalize(input) {
        if (!input || typeof input !== 'object' || !input.detail) return input;
        const next = { ...input };
        if (next.detail.Quantity && next.detailQuantity === undefined) {
            next.detailQuantity = next.detail.Quantity;
        }
        if (next.detail.string !== undefined && next.detailString === undefined) {
            next.detailString = next.detail.string;
        }
        delete next.detail;
        return next;
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
